import { Conversions } from '../../services/convertions/index';

export default class pBase {
  public ToObject = (): object => Conversions.TypedToJSON(this);
}
